export const tableFields = [
    {
        id: 0,
        name: 'checkbox',
        label: '',
        props: {
            width: '40px',
        },
    },  
    {
        id: 1,
        name: 'number',
        label: 'Номер УШ',
        props: {
            width: '80px',
        },
    },
    {
            id: 2,
        name: 'name',
        label: 'Наименование УШ',
    },
    {
        id: 3,
        name: 'current_documentation',
        label: 'Действующая документация',
        props: {
            width: '300px',
        },
    },
    {
        id: 4,
        name: 'presentations',
        label: 'Дата предъявления',
        props: {
            width: '250px',
        },
    },
    {
        id: 5,
        name: 'closing_date_planned',
        label: 'Плановая дата закрытия УШ',
        props: {
            width: '100px',
        },
    },
    {
        id: 6,
        name: 'closing_date_real',
        label: 'Дата закрытия',
        props: {
            width: '100px',
        },
    },
    {
        id: 7,
        name: 'files',
        label: 'Фотографии и необходимые файлы',
        props: {
            width: '300px',
        },
    },
]
